export default function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isNumber.js
// module id = 888
// module chunks = 1